import { readState, saveState } from '../DOMStateStorage';

const STATE_KEY_PREFIX = '@@scroll|';

export default class StateStorage {
  constructor(history) {
    this.history = history;
  }

  read(location, key) {
    return readState(this.getStateKey(location, key));
  }

  save(location, key, value) {
    saveState(this.getStateKey(location, key), value);
  }

  getStateKey(location, key) {
    const locationKey = key || location.key || this.history.createHref(this.history.location);
    const stateKeyBase = `${STATE_KEY_PREFIX}${locationKey}`;

    return key == null ? stateKeyBase : `${stateKeyBase}|${key}`;
  }

  clearStorage() {
    Object.keys(window.sessionStorage).forEach((key) => {
      if (key.indexOf(STATE_KEY_PREFIX) > 0) {
        window.sessionStorage.removeItem(key);
      }
    });
  }
}
